import styled from 'styled-components';
import Flex from '@deprecated-ui/common/Flex';
import device from '@deprecated-ui/_style/device';
import color from '@deprecated-ui/_style/color';

export const ComparisonContainer = styled.section`
  margin: 100px 0;

  h2 {
    text-align: center;
    margin-bottom: 20px;
    @media ${device.laptop} {
      text-align: left;
    }
  }

  &>.note {
    margin-top: 20px;
    @media ${device.laptop} {
      display: none;
    }
  }

  .note {
    p {
      display: block;
      padding-left: 15px;
      position: relative;

      &:before {
        content: '*)';
        position: absolute;
        top: 0;
        left: 0;
      }
    }
  }
`;

export const GraphContainer = styled.section`
  width: 100%;
  @media ${device.laptop} {
    display: grid;
    grid-template-columns: 0.6fr 1.4fr;
    grid-template-rows: 1fr;
    grid-column-gap: 50px;
    grid-row-gap: 0px; 
  }
`;

export const GraphSidebar = styled(Flex).attrs({ align: 'flex-start' })`
  flex-direction: column;

  .note {
    display: none;
    @media ${device.laptop} {
      display: block;
    }
  }

  @media ${device.laptop} {
    justify-content: space-between;
    padding: 58px 0;
  }
`;

export const GraphInputContainer = styled(Flex).attrs({ justify: 'space-between', align: 'flex-start' })`
  width: 100%;
  flex-direction: column;

  @media ${device.tablet} {
    flex-direction: row;
  }

  @media ${device.laptop} {
    flex-direction: column;
  }

  > div {
    width: 100%;
    margin-bottom: 20px;
    div {
      text-align: center;
      align-items: center;
      justify-content: center;

      @media ${device.laptop} {
        justify-content: flex-start;
        text-align: left;
      }
    }


    @media ${device.tablet} {
      width: 50%;
      margin: 10px 10px 50px 10px;
    }

    @media ${device.laptop} {
      width: 100%;
      margin-bottom: 20px;
    }
  }
`;

export const GraphContent = styled(Flex)`
  width: 100%;
  position: relative;
  flex-direction: column-reverse;
  @media ${device.laptop} {
    flex-direction: column;
  }
`;

export const Input = styled.input`
  border: 0;
  border-bottom: solid 1px ${color.gainsboro};
  font-family: inherit;
  font-weight: bold;
  font-size: 30px;
  color: ${color.nightRider};
  width: auto;
  max-width: 90%;

  &:focus {outline: none; border-bottom: solid 1px ${color.primary}}
`;

export const GraphContentInfo = styled(Flex).attrs({ direction: 'row', justify: 'space-between', align: 'flex-start' })`
  max-width: 100%;
  margin: 25px 0;
  width: 384px;

  > div {
    width: 50%;
    margin-right: 25px;
  }
  .sfaqchart-l {
    width: 15px;
    height: 10px;
    margin-top: 4px;
    margin-right: 10px;

    &.l-deposito {
      background-color: #0099e5;
    }

    &.l-saham {
      background-color: #34bf49;
    }
  }
  @media ${device.laptop} {
    margin: 0 0 25px 105px;
  }
`;
